import SwipeEvent from "./swipe_event";
import { CustomEvent } from "../types";

export const EventMap: Record<string, CustomEvent> = {
  swipe: new SwipeEvent(),
};
